<template>
  <div class="renter-addItem">
    <div class="steps">
      <div class="title">
        <i class="icon icon-caidangongneng"></i>
        <span v-if="!edit">{{ $t('crm_renter_item.xin_zeng_zu_lin_fang') }}</span>
        <span v-else>{{ $t('crm_renter_item.bian_ji_zu_lin_fang') }}</span>
      </div>
      <t-step v-model="tabActive" :list="stepList" @change="changeStep"></t-step>
    </div>
    <div class="warpper">
      <!--基础 企业 个体都是-->
      <renter-item-info-us
        v-if="tabActive === 1 && (enterpriseType === 1 || enterpriseType === 2) &&funcView.partner_renter_simple"
        :partnerId="partnerId"
        :orgId="orgId"
        :enterpriseType="enterpriseType"
        v-model="enterpriseType"
        @cancel="onCancel"
        @success="nextStep"
        @syncPartnerId="syncPartnerId"
        @previous="previous"
      ></renter-item-info-us>
      <!--基础 企业 个体都是-->
      <renter-item-info
        v-if="tabActive === 1 && (enterpriseType === 1 || enterpriseType === 2)&&!funcView.partner_renter_simple"
        :partnerId="partnerId"
        :orgId="orgId"
        :propsFuncView="funcView"
        :enterpriseType="enterpriseType"
        v-model="enterpriseType"
        @cancel="onCancel"
        @success="nextStep"
        @syncPartnerId="syncPartnerId"
        @previous="previous"
      ></renter-item-info>
      <!--基础 企业 个体都是-->
      <renter-item-institutions
        v-if="tabActive === 1 && enterpriseType === 3"
        :partnerId="partnerId"
        :orgId="orgId"
        :propsFuncView="funcView"
        :enterpriseType="enterpriseType"
        v-model="enterpriseType"
        @cancel="onCancel"
        @success="nextStep"
        @syncPartnerId="syncPartnerId"
        @previous="previous"
      ></renter-item-institutions>
      <!--基础 企业 个体都是-->
      <renter-item-infoReligion
        v-if="tabActive === 1 && enterpriseType === 4"
        :partnerId="partnerId"
        :orgId="orgId"
        :propsFuncView="funcView"
        :enterpriseType="enterpriseType"
        v-model="enterpriseType"
        @cancel="onCancel"
        @success="nextStep"
        @syncPartnerId="syncPartnerId"
        @previous="previous"
      ></renter-item-infoReligion>
      <!-- 个人 -->
      <renter-item-personal
        v-if="tabActive === 1 && enterpriseType === 5"
        :partnerId="partnerId"
        :orgId="orgId"
        :propsFuncView="funcView"
        :enterpriseType="enterpriseType"
        v-model="enterpriseType"
        @cancel="onCancel"
        @success="nextStep"
        @syncPartnerId="syncPartnerId"
        @previous="previous"
      ></renter-item-personal>
      <!--联系人-->
      <renter-item-contacts v-if="tabActive === 2"  :required="!funcView.partner_renter_simple" :partnerId="partnerId" :partnerOrgId="partnerOrgId" @success="nextStep" @previous="previous"></renter-item-contacts>
      <!-- 管理员信息 -->
      <renter-item-administrators
        v-if="tabActive === 3"
        :partnerId="partnerId"
        :enterpriseType="enterpriseType"
        @success="nextStep"
        @jumpOut="jumpOut"
        @previous="previous"
        @previousinfo="previousInfo"
      ></renter-item-administrators>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import tStep from '@/components/step.vue';
import renterItemAdministrators from '@/pages/crm/components/partnerCommon/partner_item_administrators.vue';
import renterItemInfo from './renter_item_info.vue';
import renterItemInstitutions from './renter_item_info_institutions.vue';
import renterItemInfoReligion from './renter_item_info_religion.vue';
import renterItemPersonal from './renter_item_info_personal.vue';
import renterItemInfoUs from './renter_item_info_us.vue';

// import renterItemContacts from '@/pages/crm/components/partnerCommon/partner_item_contacts';
import renterItemContacts from './renter-contact.vue';

export default {
  name: 'renter_item',
  components: { tStep, renterItemInfoUs, renterItemInfo, renterItemInstitutions, renterItemInfoReligion, renterItemPersonal, renterItemContacts, renterItemAdministrators },
  data() {
    return {
      tabActive: 1,
      enterpriseType: 1, // 1-企业，2-个体工商户，3-事业单位，4-宗教活动场所，5-其他
      // stepList: [],

      partnerId: '',
      partnerOrgId: '',
      edit: false,
      // 第一步的数据用来共享
      infoForm: {},
      orgId: ''
    };
  },
  // watch: {
  //   enterpriseType(val) {
  //     this.onEnterpriseType(val);
  //   }
  // },
  computed: {
    stepList() {
      let list = [];
      if (`${this.enterpriseType}` === '5') {
        list = [
          {
            label: 1,
            value: 1,
            title: this.$t('crm_renter_item.ji_ben_xin_xi'),
            subTitle: this.$t('crm_renter_item.zlfjbxxtx'),
          },

          {
            label: 3,
            value: 3,
            title: this.$t('crm_renter_item.guan_li_yuan_xin_xi'),
            subTitle: this.$t('crm_renter_item.ptglyxxgl'),
          },
        ];
      } else {
        list = [
          {
            label: 1,
            value: 1,
            title: this.$t('crm_renter_item.ji_ben_xin_xi'),
            subTitle: this.$t('crm_renter_item.zlfjbxxtx'),
          },
          {
            label: 2,
            value: 2,
            title: this.$t('crm_renter_item.lian_xi_ren'),
            subTitle: this.$t('crm_renter_item.zlflxrgl'),
          },
          {
            label: 3,
            value: 3,
            title: this.$t('crm_renter_item.guan_li_yuan_xin_xi'),
            subTitle: this.$t('crm_renter_item.ptglyxxgl'),
          },
        ];
      }

      return list;
    },
  },
  mounted() {
    this.getFuncView('/customer/renter');
    // 获取id   有去获取详情 无就新增
    this.partnerId = this.getJump('renterId');
    this.partnerOrgId = this.getJump('partnerOrgId');
    this.orgId = this.getJump('orgId');
    if (this.partnerId) {
      this.edit = true;
      this.getCompanyDetail();
    }
    // 清除缓存
    // this.clearKeepAlive('renter');
  },
  methods: {
    // 获取详情  同步类型
    getCompanyDetail: function () {
      if (!this.partnerId) {
        return;
      }
      this.$getJSON(apis.partnerInfo, { partnerId: this.partnerId }).then((res) => {
        if (res.code === 0) {
          this.enterpriseType = res.data.enterpriseType || 1;
          // this.onEnterpriseType(this.enterpriseType);
        }
      });
    },
    // 取消
    onCancel() {
      this.clearTagByKeep('renter_item');
      const parentPath = this.getJump('parentPath');
      if (parentPath) {
        this.jump(parentPath, {}, true);
      } else {
        this.jump('/customer/renter', {}, true);
      }
    },
    // 初始化
    nextStep: function (num) {
      this.clearKeepAlive('renter');
      this.tabActive = num;
    },
    previous: function () {
      this.tabActive = --this.tabActive;
    },
    previousInfo: function () {
      this.tabActive = 1;
    },
    // 编辑的时候点击步骤
    changeStep: function (arg) {
      if (this.edit) {
        this.tabActive = arg.value;
      }
    },
    syncPartnerId: function (partnerId, partnerOrgId) {
      this.partnerId = partnerId;
      this.partnerOrgId = partnerOrgId;
    },
    // 完成跳转
    jumpOut: function () {
      this.clearTagByKeep('renter_item');
      const parentPath = this.getJump('parentPath');
      if (parentPath) {
        this.jump(parentPath, {}, true);
      } else {
        this.jump('/customer/renter', {}, true);
      }
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';
.renter-addItem {
  // display: flex;
  // height: 100%;
  // background-color: #ffffff;
  height: 100%;
  position: relative;
  overflow: auto;
  .steps {
    position: absolute;
    left: 0;
    top: 0;
    width: 220px;
    bottom: 0;
    background-color: #f9f9fd;
    .title {
      height: 70px;
      line-height: 70px;
      padding-left: 18px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(57, 70, 104, 1);
      .icon {
        color: #0d9ae0;
        // color: $main-color;
        font-size: 13px;
        margin-right: 10px;
      }
    }
  }
  .warpper {
    background-color: #ffffff;
    margin-left: 220px;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    min-width: 1200px;
    .enterprise {
      // padding: 38px 24px 11px;
      // margin: 24px 0 24px 24px;
      // margin: 24px;s
      // width: 220px;
      padding: 24px;
      // margin-right: 24px;
      width: 220px;
      // border: 1px solid #E4EBF2;
      border-right: 1px solid #e4ebf2;
      // border-bottom: 1px solid #E4EBF2;
      .enterprise-box {
        display: flex;
        // width: 900px;
        // justify-content: space-between;
        flex-direction: column;
        .enterprise-tab {
          flex: 1;
          // width: 234px;
          margin-bottom: 12px;
          cursor: pointer;
          background: #ffffff;
          border: 1px solid #e4ebf2;
          height: 40px;
          // padding: 16px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          position: relative;
          .title {
            height: 40px;
            font-size: 12px;
            // font-weight:bold;
            color: #495057;
            line-height: 40px;
            text-align: center;
            width: 100%;
          }
          .arrow {
            display: none;
          }
          &:last-child {
            margin-right: 0;
          }
        }

        .enterprise-tab.active {
          border: 2px solid #0d9ae0;
          .title {
            font-weight: bold;
          }
          .arrow {
            position: absolute;
            right: -1px;
            bottom: -3px;
            font-size: 28px;
            color: #0d9ae0;
            display: block;
          }
        }
      }
    }

    .content {
      flex: 1;
      display: flex;
      flex-direction: column;
      height: 100%;
      .content-box {
        flex: 1;
        padding: 24px;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
      }
      // .renter-info{
      //   padding: 14px 0 24px 0 !important;
      // }
      .btn-group {
        border-top: 1px solid #eef2f8;
        padding: 16px 0 16px 24px;
        height: 60px;
        z-index: 1;
        -webkit-box-flex: 0;
        flex: 0 0 60px;
      }
    }
  }
}
</style>
